import { ChangeEvent } from 'react'
import { TextField } from '@mui/material'
import * as React from 'react'

type TreeIds = {
  treeId: string
  version: string
  nodeId?: string
}

function getIds(userString: string) {
  const urlRegex =
    /^https?:\/\/[^/]+\/curriculum\/([a-f0-9-]+):([a-f0-9-]+)(?::([a-f0-9-]+)|\/node\/([a-f0-9-]+))?$/

  const urlMatch = userString.match(urlRegex)
  if (urlMatch) {
    const [_, treeId, version, nodeId] = urlMatch
    return { treeId, version, nodeId }
  }
  const idRegex = /([a-f0-9-]+):([a-f0-9-]+)(?::([a-f0-9-]+))?/
  const idMatch = userString.match(idRegex)
  if (idMatch) {
    const [treeId, version, nodeId] = idMatch
    return { treeId, version, nodeId }
  }
  return {}
}

export function TreeTextField({
  value = '',
  onChange,
  disabled = false,
}: {
  readonly value?: string
  readonly onChange: (ids: TreeIds) => void
  readonly disabled?: boolean
}) {
  function treeIdChange({
    target: { value },
  }: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
    const ids = getIds(value)
    if (ids.treeId && ids.version) {
      onChange(ids)
    }
  }

  return (
    <TextField
      disabled={disabled}
      value={value}
      label="TreeId or URL"
      fullWidth={true}
      onChange={treeIdChange}
    />
  )
}
